enum Events {
  // Authentication events
  LoginEvent = 'login',
  LogoutEvent = 'logout',
  SignUpEvent = 'sign_up',

  // E-commerce events
  PurchaseEvent = 'purchase',
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
  ViewItem = 'view_item',
  ViewItemList = 'view_item_list',
  SelectItem = 'select_item',
  BeginCheckout = 'begin_checkout',
  AddPaymentInfo = 'add_payment_info',
  AddShippingInfo = 'add_shipping_info',

  // Search events
  Search = 'search',
  ViewSearchResults = 'view_search_results',

  // User engagement
  UserDataEvent = 'userData',
  PageView = 'page_view',

  Error = 'page_error',
}

export default Events
